import React from 'react';
import Popup from 'devextreme-react/popup';
import DataGrid, { Column, Scrolling, Paging } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';

const ShowNegativeValueForShipment = ({ visible, onHiding, dataSource, transactionNumber }) => {
    return (
        <Popup
            visible={visible}
            onHiding={onHiding}
            dragEnabled={true}
            showCloseButton={true}
            showTitle={true}
            title={`Show Negative Inventory For Shipments(${transactionNumber || ''})`}
            width={750}
            height={500}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div style={{ padding: '10px', fontSize: '13px', lineHeight: '1.5' }}>
                    The Transaction Data Profile is set to validate for <strong>"Negative Inventory Quantities"</strong> upon Exiting the
                    transaction. This Shipment Transaction has <strong>"Negative Inventory Quantities"</strong> in the Location(s) listed
                    below. Please re-enter the correct Shipped Quantity for the <strong>"Location(s)"</strong> before proceeding.
                </div>
                <div style={{ flex: 1, padding: '0 10px' }}>
                    <DataGrid
                        dataSource={dataSource}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        columnAutoWidth={true}
                        height="100%"
                    >
                        <Scrolling mode="virtual" />
                        <Paging enabled={false} />
                        <Column dataField="itemCode" caption="Item" />
                        <Column dataField="lotCode" caption="Lot" />
                        <Column dataField="subLotCode" caption="Sublot" />
                        <Column dataField="location" caption="Location" />
                        <Column dataField="available" caption="Available" dataType="number" />
                        <Column dataField="shippedQuantity" caption="Ship Quantity" dataType="number" />
                    </DataGrid>
                </div>
               
            </div>
        </Popup>
    );
};

export default ShowNegativeValueForShipment;
